import * as tokens from '@utmost.co/utmost-design-tokens';
import { Components } from '../../../styles';

export const switchTheme = {
  MuiSwitch: {
    styleOverrides: {
      root: {
        width: 52,
        height: 32,
        padding: 0,
        overflow: 'unset',

        '&.MuiSwitch-sizeSmall': {
          width: 39,
          height: 24,
          '&.without-icon .MuiSwitch-switchBase:not(.Mui-checked)': {
            top: 4,
            left: 4,
            width: 12,
            height: 12
          },

          '&.without-icon': {
            left: 1,
            top: 2
          },
          '&.with-icon': {
            left: 2,
            top: 2,
            '.ripple-start': {
              transform: 'scale(1.4)'
            }
          },
          '& .MuiSwitch-switchBase': {
            width: 16,
            height: 16,
            '&::after': {
              position: 'absolute',
              left: -7,
              top: -7,
              borderRadius: '50%',
              height: 30,
              width: 30,
              zIndex: 1
            },

            '&.Mui-checked': {
              transform: 'translateX(16px)',
              '&.ripple-start': {
                transform: 'translateX(16px) scale(1.3)'
              }
            }
          }
        },

        '&.without-icon .MuiSwitch-switchBase:not(.Mui-checked)': {
          width: 16,
          height: 16,
          top: 6,
          left: 6,
          '&.ripple-start': {
            transform: 'scale(1.8)'
          },
          '&::after': {
            height: 30,
            width: 30
          }
        },
        '& .MuiSwitch-switchBase': {
          padding: 0,
          margin: 2,
          left: 2,
          top: 2,
          width: 24,
          height: 24,

          transitionDuration: '300ms',
          backgroundColor: tokens.colorOnSurface,

          transform: 'translateX(0px) scale(1)',
          '&.ripple-start': {
            transform: 'scale(1.1)'
          },
          '&::after': {
            position: 'absolute',
            left: -8,
            top: -8,
            borderRadius: '50%',
            height: 40,
            width: 40,
            zIndex: 1
          },
          '.material-symbols-rounded': {
            fill: tokens.colorInverseOnSurface,
            color: tokens.colorInverseOnSurface,
            position: 'relative'
          },
          '&.Mui-disabled': {
            backgroundColor: tokens.stateOnSurfaceDisabledContainerStateLayerColor,
            '.material-symbols-rounded': {
              fill: tokens.stateOnSurfaceDisabledContentStateLayerColor,
              color: tokens.stateOnSurfaceDisabledContentStateLayerColor
            }
          },
          '&:hover, &:focus-within': {
            backgroundColor: tokens.colorOnSurface,
            '&::after': {
              content: "''",
              backgroundColor: tokens.stateOnSurfaceHoverStateLayerColor
            }
          },
          '&.Mui-checked': {
            transform: 'translateX(20px)',
            '&.ripple-start': {
              transform: 'translateX(20px) scale(1.1)'
            },
            backgroundColor: tokens.colorOnPrimary,
            '.material-symbols-rounded': {
              fill: tokens.colorOnSurface,
              color: tokens.colorOnSurface
            },
            '&.Mui-disabled': {
              backgroundColor: tokens.stateOnSurfaceDisabledContainerStateLayerColor,
              '.material-symbols-rounded': {
                fill: tokens.stateOnSurfaceDisabledContentStateLayerColor,
                color: tokens.stateOnSurfaceDisabledContentStateLayerColor
              }
            },
            '&:hover, &:focus, &:focus-within': {
              backgroundColor: tokens.colorPrimaryContainer,
              '&::after': {
                content: "''",
                backgroundColor: tokens.statePrimaryFocusStateLayerColor
              }
            },
            '& + .MuiSwitch-track': {
              backgroundColor: tokens.colorPrimary,
              opacity: 1,
              border: 0
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              backgroundColor: tokens.stateOnSurfaceDisabledContainerStateLayerColor
            }
          }
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 22,
          height: 22
        },
        '& .MuiSwitch-track': {
          borderRadius: 100,
          backgroundColor: 'transparent',
          opacity: 1,
          transition: 'background-color 500ms',
          border: `2px solid ${tokens.colorOutline}`,
          '&.Mui-checked': {
            borderColor: tokens.colorPrimary
          }
        }
      }
    }
  }
} satisfies Components;
